import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';

const DesktopFlightItem = dynamic(() => import('./DesktopFlightItem'), {
  ssr: false,
});

const MobileFlightItem = dynamic(() => import('./MobileFlightItem'), {
  ssr: false,
});
import { FlightProps } from '../../helper';

const FlightItem = (props: {
  flightItem: FlightProps;
  selectedFlightItem: FlightProps;
  setSelectedFlight: (any) => void;
  isListing?: boolean;
  minPriceItem?: FlightProps;
}) => {
  const { isDesktop } = useDevice();
  return isDesktop ? (
    <DesktopFlightItem {...props} />
  ) : (
    <MobileFlightItem {...props} />
  );
};
export default FlightItem;
